module.exports = "/assets/data/1b87eb03836fc263db5aa578e8f5d89e-TS7.data.json";